import { useScript } from '#imports'

export const useTurnstile = () => {
    return useScript({
        id: 'cloudflare-turnstile',
        src: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit',
        defer: true,
        async: true,
    }, {
        trigger: 'onNuxtReady',
        use: () => {
            return { turnstile: window.turnstile }
        }
    })
}
